import * as React from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import TimelineDot from "@mui/lab/TimelineDot";
import Typography from "@mui/material/Typography";
import AdjustIcon from "@mui/icons-material/Adjust";
export default function CustomizedTimeline() {
  return (
    <Timeline position="alternate">
    <TimelineItem>
        <TimelineOppositeContent
          sx={{ m: "auto 0" }}
          align="right"
          variant="body2"
          color="text.secondary"
        >
          2023
        </TimelineOppositeContent>
        <TimelineSeparator>
          
          <TimelineDot color="primary">
            <AdjustIcon />
          </TimelineDot>
        </TimelineSeparator>
        <TimelineContent sx={{ py: "12px", px: 2 }}>
          <Typography variant="h6" component="span">
            Power Cord Egypt
          </Typography>
          <Typography>
            Expand to a world market
            <br />
            manufacturing factory
          </Typography>
        </TimelineContent>
      </TimelineItem>
      
      <TimelineItem>
        <TimelineOppositeContent
          sx={{ m: "auto 0" }}
          align="right"
          variant="body2"
          color="text.secondary"
        >
          2014
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineConnector />
          <TimelineDot variant="outlined">
            <AdjustIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: "12px", px: 2 }}>
          <Typography variant="h6" component="span">
            Power Cord Founding{" "}
          </Typography>
          <Typography>
          Forming an integrated industrial group consisting of three factories that supply goods to electrical appliances and complement each otherز
          </Typography>
        </TimelineContent>
      </TimelineItem>
      
    </Timeline>
  );
}
